import styled from "styled-components";

export const DatetimeXAxisAreaChart = styled.div`
  height: 100%;
  width: 100%;
`
